
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import cookie from 'vux/src/tools/cookie/index.js'


import qs from 'qs'

import Vue from 'vue'
import router from '@/router'

import api from '@/utils/api'

import utils from '@/utils/utils'

import config from '@/utils/config'


AjaxPlugin.$http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
AjaxPlugin.$http.defaults.headers['Authorization'] = cookie.get('openid')
AjaxPlugin.$http.defaults.timeout = 30000;
AjaxPlugin.$http.defaults.baseURL = config.baseUrl

AjaxPlugin.$http.interceptors.request.use(
config => {
if (config.method === 'post') {
if (!(config.data instanceof FormData)) {
config.data = qs.stringify(config.data)
}
}

return new Promise((resolve, reject) => {
resolve(config)
})
},
error => {
return Promise.reject(error);
}
);

AjaxPlugin.$http.interceptors.response.use(
response => {
if ((response.data.code && response.data.code !== 0) || (response.data.code === 0 && !response.data.success)) {
if(response.data.code == 401){
cookie.remove('token')

}
}
return response;
},
error => {
return Promise.reject(error);
}
)

export default AjaxPlugin


// WEBPACK FOOTER //
// ./src/utils/request.js